import { get, groupBy, map } from 'lodash'

import { toLines } from '../../../../common/utils'

import {
  EXTRA_INGREDIENT_TYPES,
  INGREDIENT_PHRASE_TYPES,
} from '../../../constants'

const ingredientExtraDetailsFormInitialValues = ({
  phrases,
  extraIngredients,
}) => {
  const phrasesGroupedByType = groupBy(phrases, 'type')
  const extraIngredientsGroupedByType = groupBy(extraIngredients, 'type')

  return {
    pairingPhrases: toLines(
      map(get(phrasesGroupedByType, INGREDIENT_PHRASE_TYPES.PAIRING), 'phrase'),
    ),
    referencingPhrases: toLines(
      map(
        get(phrasesGroupedByType, INGREDIENT_PHRASE_TYPES.REFERENCING),
        'phrase',
      ),
    ),
    negativeSynonymPhrases: toLines(
      map(
        get(phrasesGroupedByType, INGREDIENT_PHRASE_TYPES.NEGATIVE_SYNONYM),
        'phrase',
      ),
    ),

    pairingIngredientIds:
      map(
        get(extraIngredientsGroupedByType, EXTRA_INGREDIENT_TYPES.PAIRING),
        ({ id, name }) => ({ value: id, title: name }),
      ) || [],

    referenceIngredientIds: map(
      get(extraIngredientsGroupedByType, EXTRA_INGREDIENT_TYPES.REFERENCE),
      ({ id, name }) => ({ value: id, title: name }),
    ),
  }
}

export default ingredientExtraDetailsFormInitialValues
